import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetWorkspaceFormPanel } from "@/features/assets/components";
import { assetInstanceQueryOptions } from "@/services/asset";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/form",
)({
	component: OrgAssetWorkspaceFormTab,
});

function OrgAssetWorkspaceFormTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/form",
	});
	const assetById = useQuery(
		assetInstanceQueryOptions.detail(params.assetId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<AssetWorkspaceFormPanel
			asset={assetById.data}
			assetId={params.assetId}
			organizationId={params.orgId}
			isAssetPending={assetById.isPending}
		/>
	);
}
